"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConstructorNames = getConstructorNames;
var publicExportNames;
// Lazy require to avoid circular deps — main.ts can't be statically imported while Component is initializing.
function getPublicExportName(constructor) {
    if (publicExportNames == null) {
        publicExportNames = new Map();
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        var publicExports = require('../main');
        for (var _i = 0, _a = Object.keys(publicExports); _i < _a.length; _i++) {
            var exportName = _a[_i];
            var exportValue = publicExports[exportName];
            if (typeof exportValue === 'function' && !publicExportNames.has(exportValue)) {
                publicExportNames.set(exportValue, exportName);
            }
        }
    }
    return publicExportNames.get(constructor);
}
// Uses export names from main.ts instead of constructor.name so overrides work in minified builds.
function getConstructorNames(constructor) {
    var _a;
    var constructorNames = [];
    var prototype = constructor.prototype;
    while (prototype && prototype.constructor) {
        var constructorName = (_a = getPublicExportName(prototype.constructor)) !== null && _a !== void 0 ? _a : prototype.constructor.name;
        if (!constructorName) {
            break;
        }
        constructorNames.unshift(constructorName);
        prototype = Object.getPrototypeOf(prototype);
    }
    return constructorNames;
}
